import Voucher from '@/pages/library/voucher/routes'
import MemberPreferences from '@/pages/library/preferences/routes'

export default {
  path: 'library',
  component: () => import('@/components/layouts/ChildLayout.vue'),
  children: [Voucher, ...MemberPreferences]
}
